/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { QuestConfig } from './QuestConfig';
import {
    QuestConfigFromJSON,
    QuestConfigFromJSONTyped,
    QuestConfigToJSON,
    QuestConfigToJSONTyped,
} from './QuestConfig';

/**
 * 
 * @export
 * @interface GetAllQuestConfigsForUserResponse
 */
export interface GetAllQuestConfigsForUserResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetAllQuestConfigsForUserResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<QuestConfig>}
     * @memberof GetAllQuestConfigsForUserResponse
     */
    questConfigs: Array<QuestConfig>;
}

/**
 * Check if a given object implements the GetAllQuestConfigsForUserResponse interface.
 */
export function instanceOfGetAllQuestConfigsForUserResponse(value: object): value is GetAllQuestConfigsForUserResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('questConfigs' in value) || value['questConfigs'] === undefined) return false;
    return true;
}

export function GetAllQuestConfigsForUserResponseFromJSON(json: any): GetAllQuestConfigsForUserResponse {
    return GetAllQuestConfigsForUserResponseFromJSONTyped(json, false);
}

export function GetAllQuestConfigsForUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllQuestConfigsForUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'questConfigs': ((json['questConfigs'] as Array<any>).map(QuestConfigFromJSON)),
    };
}

export function GetAllQuestConfigsForUserResponseToJSON(json: any): GetAllQuestConfigsForUserResponse {
    return GetAllQuestConfigsForUserResponseToJSONTyped(json, false);
}

export function GetAllQuestConfigsForUserResponseToJSONTyped(value?: GetAllQuestConfigsForUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'questConfigs': ((value['questConfigs'] as Array<any>).map(QuestConfigToJSON)),
    };
}

